import { Award, Users, MessageSquare, Zap } from "lucide-react"
import { SectionReveal, StaggerReveal, StaggerItem, FadeScale } from "~/components/company/SectionReveal"

const reasons = [
  {
    icon: Award,
    title: "10+ Years Building Real Products",
    description: "Silicon Valley engineer who's shipped production web apps. You're not hiring random freelancers. You're working with experienced builders who know what actually works."
  },
  {
    icon: Zap,
    title: "Get Your Time Back",
    description: "We handle product and engineering end-to-end. Free up 10-20 hours a week to focus on sales, users, and revenue instead of managing dev work."
  },
  {
    icon: MessageSquare,
    title: "Built Right From The Start",
    description: "Poor code leads to bugs, delays, and expensive rewrites. We build it right so you don't pay 2-3x fixing shortcuts later."
  },
  {
    icon: Users,
    title: "We Stay After Launch",
    description: "Most teams stall after V1. We stay through iteration and improvements so your product keeps shipping. Faster velocity to revenue and product-market fit."
  }
]

export function WhyUsSection() {
  return (
    <section className="w-full bg-white py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-12">
          <SectionReveal className="space-y-4 text-center">
            <p className="text-[#ed2132] font-semibold">WHY CHOOSE US</p>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
              Proven Track Record Building Real Products
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              We&apos;re not an outsourcing shop. We&apos;re experienced builders who take ownership of your product.
            </p>
          </SectionReveal>

          <StaggerReveal className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {reasons.map((reason, index) => {
              const Icon = reason.icon
              return (
                <StaggerItem key={index}>
                  <div className="space-y-4 p-4 rounded-lg hover:bg-slate-50 transition-colors duration-300">
                    <div className="flex items-center gap-4">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-red-100">
                          <Icon className="w-6 h-6 text-[#ed2132]" />
                        </div>
                      </div>
                      <h3 className="text-xl font-semibold text-slate-900">{reason.title}</h3>
                    </div>
                    <p className="text-slate-600 ml-16">{reason.description}</p>
                  </div>
                </StaggerItem>
              )
            })}
          </StaggerReveal>

          <FadeScale>
            <div className="bg-red-50 border border-red-200 rounded-lg p-8 hover:shadow-lg transition-shadow duration-500">
              <div className="space-y-4">
                <p className="text-slate-600 text-sm">SAVE $15K-$30K+ IN HIRING COSTS</p>
                <p className="text-3xl font-bold text-slate-900">
                  Skip the 4-8 week hiring process. Start building right away.
                </p>
                <p className="text-slate-600">
                  A full senior team ready to go. No recruiting, no onboarding, no management overhead.
                </p>
              </div>
            </div>
          </FadeScale>
        </div>
      </div>
    </section>
  )
}
